import { GetStaticPropsContext } from 'next'

import { MenuData } from '../models/header'

export const headerData: MenuData = {
  menu: {
    id: 'TWVudTox',
    items: [
      {
        id: 'storybooks',
        name: 'Storybooks',
        translation: null,
        category: {
          id: 'storybooks-cat',
          slug: 'storybooks',
          url: '/storybooks',
        },
        collection: null,
        page: null,
        url: null,
        children: [
          {
            id: 'adventure',
            name: 'Adventure Stories',
            translation: null,
            category: {
              id: 'adventure-cat',
              slug: 'adventure',
              url: '/storybooks/adventure',
            },
            collection: null,
            page: null,
            url: null,
            children: [],
          },
          {
            id: 'fantasy',
            name: 'Fantasy Stories',
            translation: null,
            category: {
              id: 'fantasy-cat',
              slug: 'fantasy',
              url: '/storybooks/fantasy',
            },
            collection: null,
            page: null,
            url: null,
            children: [],
          },
          {
            id: 'educational',
            name: 'Educational Stories',
            translation: null,
            category: {
              id: 'educational-cat',
              slug: 'educational',
              url: '/storybooks/educational',
            },
            collection: null,
            page: null,
            url: null,
            children: [],
          },
          {
            id: 'bedtime',
            name: 'Bedtime Stories',
            translation: null,
            category: {
              id: 'bedtime-cat',
              slug: 'bedtime',
              url: '/storybooks/bedtime',
            },
            collection: null,
            page: null,
            url: null,
            children: [],
          },
        ],
      },
      {
        id: 'by-age',
        name: 'By Age',
        translation: null,
        category: null,
        collection: null,
        page: null,
        url: '/storybooks',
        children: [
          {
            id: 'age-0-3',
            name: '0-3 Years',
            translation: null,
            category: null,
            collection: null,
            page: null,
            url: '/storybooks?age=0-3',
            children: [],
          },
          {
            id: 'age-4-6',
            name: '4-6 Years',
            translation: null,
            category: null,
            collection: null,
            page: null,
            url: '/storybooks?age=4-6',
            children: [],
          },
          {
            id: 'age-7-9',
            name: '7-9 Years',
            translation: null,
            category: null,
            collection: null,
            page: null,
            url: '/storybooks?age=7-9',
            children: [],
          },
        ],
      },
      {
        id: 'occasions',
        name: 'Occasions',
        translation: null,
        category: null,
        collection: null,
        page: null,
        url: '/storybooks',
        children: [
          {
            id: 'birthday',
            name: 'Birthday',
            translation: null,
            category: null,
            collection: null,
            page: null,
            url: '/storybooks?occasion=birthday',
            children: [],
          },
          {
            id: 'christmas',
            name: 'Christmas',
            translation: null,
            category: null,
            collection: null,
            page: null,
            url: '/storybooks?occasion=christmas',
            children: [],
          },
          {
            id: 'new-baby',
            name: 'New Baby',
            translation: null,
            category: null,
            collection: null,
            page: null,
            url: '/storybooks?occasion=new-baby',
            children: [],
          },
        ],
      },
    ],
  },
}

export const headerQuery = async (_context: GetStaticPropsContext) => {
  // TODO: if we ever customise the backend to update the header categories, the api call can go below.

  return headerData
}